import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';

import state from '../state';

import { MyDraggable as Draggable, Dropzone } from '../components/Core';
import HoverBar from '../components/HoverBar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import CancelIcon from '@material-ui/icons/Cancel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { generateStyle, l, setOverLay } from '../functions';
import Icon from '../components/Icons';

const mapStateToProps = (state) => {
  return {
    elementOptions: state.rootReducer.elementOptions || [],
    currentDevice: state.rootReducer.currentDevice || 'xl',
    settings: state.rootReducer?.appearanceSettings || {},
  };
};

class GRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnWidth: false,
      currentsize: 'xl',
      columns: this.defaultColumns,
      initialElements: [],
      frameVersion: 1,
    };

    this.defaultColumns = {
      xl: [3, 7, 2],
      lg: [4, 6, 2],
      md: [5, 5, 2],
      sm: [6, 6, 12],
      xs: [12, 0, 0],
    };

    this.colCount = {
      xl: [
        [],
        [12],
        [6, 6],
        [4, 4, 4],
        [3, 3, 3, 3],
        [3, 3, 2, 2, 2],
        [2, 2, 2, 2, 2, 2],
        [2, 2, 2, 2, 2, 1, 1],
        [2, 1, 2, 1, 2, 1, 2, 1],
        [2, 1, 2, 1, 2, 1, 1, 1, 1],
        [2, 1, 2, 1, 1, 1, 1, 1, 1, 1],
        [2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      ],
      lg: [
        [],
        [12],
        [6, 6],
        [4, 4, 4],
        [3, 3, 3, 3],
        [3, 3, 2, 2, 2],
        [2, 2, 2, 2, 2, 2],
        [2, 2, 2, 2, 2, 1, 1],
        [2, 1, 2, 1, 2, 1, 2, 1],
        [2, 1, 2, 1, 2, 1, 1, 1, 1],
        [2, 1, 2, 1, 1, 1, 1, 1, 1, 1],
        [2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      ],
      md: [
        [],
        [12],
        [6, 6],
        [4, 4, 4],
        [3, 3, 3, 3],
        [3, 3, 2, 2, 2],
        [2, 2, 2, 2, 2, 2],
        [2, 2, 2, 2, 2, 1, 1],
        [2, 1, 2, 1, 2, 1, 2, 1],
        [2, 1, 2, 1, 2, 1, 1, 1, 1],
        [2, 1, 2, 1, 1, 1, 1, 1, 1, 1],
        [2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      ],
      sm: [
        [],
        [12],
        [6, 6],
        [4, 4, 4],
        [3, 3, 3, 3],
        [3, 3, 2, 2, 2],
        [2, 2, 2, 2, 2, 2],
        [2, 2, 2, 2, 2, 1, 1],
        [2, 1, 2, 1, 2, 1, 2, 1],
        [2, 1, 2, 1, 2, 1, 1, 1, 1],
        [2, 1, 2, 1, 1, 1, 1, 1, 1, 1],
        [2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      ],
      xs: [
        [],
        [12],
        [6, 6],
        [4, 4, 4],
        [3, 3, 3, 3],
        [3, 3, 2, 2, 2],
        [2, 2, 2, 2, 2, 2],
        [2, 2, 2, 2, 2, 1, 1],
        [2, 1, 2, 1, 2, 1, 2, 1],
        [2, 1, 2, 1, 2, 1, 1, 1, 1],
        [2, 1, 2, 1, 1, 1, 1, 1, 1, 1],
        [2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      ],
    };

    this.sizeLabel = {
      xl: 'Large screens',
      lg: 'Regular screens',
      md: 'Horizontal Tabs',
      sm: 'Vertical Tabs',
      xs: 'Smartphones',
    };
  }

  componentWillReceiveProps({ initialElements, fields, payload }) {
    if (initialElements && initialElements !== this.state.initialElements)
      this.setState({
        initialElements: initialElements,
        frameVersion: Math.random(),
      });

    if (payload && payload.columns && payload.columns != this.state.columns)
      this.setState({
        columns: payload.columns,
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      JSON.stringify(prevState.columns) !== JSON.stringify(this.state.columns) ||
      JSON.stringify(prevState.initialElements) !== JSON.stringify(this.state.initialElements)
    ) {
      const { id, dropzoneID, parentID, payload } = this.props;

      let updatedObject = {};

      if (JSON.stringify(prevState.columns) !== JSON.stringify(this.state.columns)) {
        updatedObject.payload = {
          ...payload,
          columns: this.state.columns,
        };
      }

      if (JSON.stringify(prevState.initialElements) !== JSON.stringify(this.state.initialElements)) {
        updatedObject.initialElements = this.state.initialElements;
        updatedObject.fields = this.state.initialElements;
      }

      state.updateElement(id, dropzoneID, parentID, updatedObject);
    }
  }

  _onDrop = (data, cb) => {
    // no need to ask id and name again
    if (data.payload && data.payload.dropped) {
      return cb(data);
    }

    // This can be an async call or some modal to fetch data

    let name = data.name;
    const id = 'gk-' + Math.floor(Math.random() * 10000 + 1);

    return cb({
      ...data,
      name,
      id,
      elementId: data.id,
      payload: {
        dropped: true,
        ...this.props.elementOptions[data.id]?.payload,
      },
    });
  };

  filterInitialElements = (dID) => {
    const { fields } = this.props;

    let toreturn = [];

    if (fields !== undefined)
      toreturn = fields
        ? fields.filter((e) => e.dropzoneID === dID) || []
        : fields.filter((e) => e.dropzoneID === dID) || [];

    return toreturn;
  };

  _colsLayout = (datas) => {
    const maxLoop = Math.max(
      (datas.xl && datas.xl.length) || 0,
      (datas.lg && datas.lg.length) || 0,
      (datas.md && datas.md.length) || 0,
      (datas.sm && datas.sm.length) || 0,
      (datas.xs && datas.xs.length) || 0
    );

    let cols = [];
    const colSizes = ['xl', 'lg', 'md', 'sm', 'xs'];

    for (let i = 0; i < maxLoop; i++) {
      let customSizes = {};
      let classNames = '';

      colSizes.forEach((size) => {
        if (datas[size]) {
          if (datas[size][i] && datas[size][i] > 0) {
            customSizes[size] = datas[size][i];
            classNames += 'd-' + (size !== 'xs' ? size : '') + '-block ';
          } else classNames += 'd-' + (size !== 'xs' ? size + '-' : '') + 'none ';
        }
      });

      cols.push({
        sizes: customSizes,
        className: '',
      });
    }

    return cols;
  };

  _generateCols = (target) => {
    const { dropzoneProps, ...rest } = this.props;
    const columns = this.state.columns || this.defaultColumns;

    const customCols = this._colsLayout(columns);
    const rowsCount = customCols.length;
    let cols = [];

    let i = 0;
    if (target === 'preview') {
      customCols.forEach((col) => {
        i = i + 1;
        cols.push(
          <Col
            xs={col.sizes[this.props.currentDevice] || 12}
            className={`row-column ${col.className}`}
            key={`canvas-${rowsCount}-${i}`}
          >
            {rest.childNode[`canvas-${rowsCount}-${i}`]}
          </Col>
        );
      });
    } else {
      customCols.forEach((col) => {
        i = i + 1;
        cols.push(
          <Col
            xs={col.sizes[this.props.currentDevice] || 12}
            className={`row-column ${col.className}`}
            key={`canvas-${rowsCount}-${i}`}
          >
            <Dropzone
              {...dropzoneProps}
              initialElements={this.filterInitialElements(`canvas-${rowsCount}-${i}`)}
              id={`canvas-${rowsCount}-${i}`}
              key={`canvas-${rowsCount}-${i}`}
              onDrop={this._onDrop}
              placeholder={null}
              version={`canvas-${rowsCount}-${i}-${this.state.frameVersion}`}
            />
          </Col>
        );
      });
    }
    return cols;
  };

  _generateRow = (target) => {
    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;

    const columns = this.state.columns || this.defaultColumns;

    let isFluid = payload.fullContainer;
    if (isFluid === undefined) {
      isFluid = true;
    }

    const rowsCount = Math.max(
      (columns.xl && columns.xl.length) || 0,
      (columns.lg && columns.lg.length) || 0,
      (columns.md && columns.md.length) || 0,
      (columns.sm && columns.sm.length) || 0,
      (columns.xs && columns.xs.length) || 0
    );

    const cssSettings = generateStyle(payload, 'container');
    return (
      <Container fluid={true} style={cssSettings}>
        {setOverLay(payload)}
        {target !== 'preview' && this.state.columnWidth && (
          <div className='column-setter-container'>
            <div className='column-setter'>
              {/* <div className="field">
                <FormControl variant="outlined">
                  <Select
                    value={rowsCount}
                    onChange={(event) => {
                      this._updateNbColumns(event.target.value);
                    }}
                  >
                    <MenuItem value={1}>1 Column</MenuItem>
                    <MenuItem value={2}>2 Columns</MenuItem>
                    <MenuItem value={3}>3 Columns</MenuItem>
                    <MenuItem value={4}>4 Columns</MenuItem>
                    <MenuItem value={5}>5 Columns</MenuItem>
                    <MenuItem value={6}>6 Columns</MenuItem>
                    <MenuItem value={7}>7 Columns</MenuItem>
                    <MenuItem value={8}>8 Columns</MenuItem>
                    <MenuItem value={9}>9 Columns</MenuItem>
                    <MenuItem value={10}>10 Columns</MenuItem>
                    <MenuItem value={11}>11 Columns</MenuItem>
                    <MenuItem value={12}>12 Columns</MenuItem>
                  </Select>
                </FormControl>
              </div> */}
              <div className='field'>
                <FormControl variant='outlined'>
                  <Select
                    value={this.state.currentsize}
                    onChange={(event) => {
                      this.setState({
                        currentsize: event.target.value,
                      });
                    }}
                  >
                    <MenuItem value='xl'>Large screens</MenuItem>
                    <MenuItem value='lg'>Regular screens</MenuItem>
                    <MenuItem value='md'>Horizontal Tabs</MenuItem>
                    <MenuItem value='sm'>Vertical Tabs</MenuItem>
                    <MenuItem value='xs'>Smartphones</MenuItem>
                  </Select>
                </FormControl>
              </div>

              <div className='field'>
                <div
                  className='close-it'
                  onClick={() => {
                    this.setState({ columnWidth: false });
                  }}
                >
                  <CancelIcon />
                </div>
                <h3>Columns width of 12</h3>
                <div className='setter-select-container'>
                  <div className='setter-select'>{this._generateColumnCounter()}</div>
                </div>
              </div>
            </div>
          </div>
        )}
        <Container fluid={isFluid}>
          <Row>{this._generateCols(target)}</Row>
        </Container>
      </Container>
    );
  };

  _generateColumnCounter = () => {
    const columns = this.state.columns || this.defaultColumns;
    const screen = this.state.currentsize;

    const rowsCount = Math.max(
      (columns.xl && columns.xl.length) || 0,
      (columns.lg && columns.lg.length) || 0,
      (columns.md && columns.md.length) || 0,
      (columns.sm && columns.sm.length) || 0,
      (columns.xs && columns.xs.length) || 0
    );

    let cols = [];

    for (let i = 0; i < rowsCount; i++) {
      cols.push(
        <FormControl key={i}>
          <Select
            value={columns[screen][i]}
            onChange={(event) => {
              this._updateColumns(i, event.target.value);
            }}
          >
            {/* <MenuItem value={0}>Hide</MenuItem>
            <MenuItem value={1}>25%</MenuItem>
            <MenuItem value={4}>50%</MenuItem>
            <MenuItem value={8}>75%</MenuItem>
            <MenuItem value={12}>100%</MenuItem> */}

            <MenuItem value={0}>Hide</MenuItem>
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={2}>2</MenuItem>
            <MenuItem value={3}>3</MenuItem>
            <MenuItem value={4}>4</MenuItem>
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={6}>6</MenuItem>
            <MenuItem value={7}>7</MenuItem>
            <MenuItem value={8}>8</MenuItem>
            <MenuItem value={9}>9</MenuItem>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={11}>11</MenuItem>
            <MenuItem value={12}>12</MenuItem>
          </Select>
        </FormControl>
      );
    }
    return cols;
  };

  _updateNbColumns = (value) => {
    this.setState({
      columns: {
        xl: this.colCount.xl[value],
        lg: this.colCount.lg[value],
        md: this.colCount.md[value],
        sm: this.colCount.sm[value],
        xs: this.colCount.xs[value],
      },
      // initialElements : this._resetdropzoneID(value),
    });
  };

  _resetdropzoneID = (value) => {
    let newFields = [];

    if (this.state.initialElements && this.state.initialElements.length > 0)
      this.state.initialElements.forEach((field) => {
        let finalField = field;
        if (field.dropzoneID && field.dropzoneID.split('-').length == 3) {
          let N1 = value;
          let N2 = field.dropzoneID.split('-')[2];

          if (N2 > N1) N2 = value;

          finalField.dropzoneID = 'canvas-' + N1 + '-' + N2;
        }

        newFields.push(finalField);
      });

    return newFields;
  };

  _updateColumns = (index, value) => {
    this.setState({
      ...this.state,
      columns: {
        ...this.state.columns,
        [this.state.currentsize]: [
          ...this.state.columns[this.state.currentsize].slice(0, index),
          value,
          ...this.state.columns[this.state.currentsize].slice(index + 1),
        ],
      },
    });
  };

  render() {
    const { dropzoneID, parentID, showBasicContent, showPreview, id, dropzoneProps, payload, ...rest } = this.props;

    const cssSettings = generateStyle(payload, 'container');
    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className='dragger'>
            {(Array.isArray(rest.icon) && <FontAwesomeIcon icon={rest.icon} />) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return this._generateRow('preview');
    }

    return (
      <Draggable {...this.props} row={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          columnEdit={() => {
            this.setState({
              columnWidth: this.state.columnWidth ? false : true,
            });
          }}
          row={this.props.type === 'row'}
          rowActiveClass={this.state.columnWidth}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._generateRow('default')}
      </Draggable>
    );
  }
}

GRow.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(GRow);
